import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Login from '../../../modulos/congresso/containers/login/Login';
import Cadastro from '../../../modulos/congresso/containers/cadastro/Cadastro';

class CongressoNavegacao extends React.Component {
    render(){
        return (            
            <Switch>
                <Route path={`${this.props.match.path}/login`} component={Login} />
                <Route path={`${this.props.match.path}/cadastro`} component={Cadastro} />
            </Switch>            
        )
    }
}

export default CongressoNavegacao;